import { createSlice } from '@reduxjs/toolkit';
import { getBatches } from 'ducks/batches/operators';
import { Slices } from 'ducks/slices';
import { BatchItem } from 'ducks/types/store-types';
import { normalizeBatches } from 'ducks/utils';

export type BatchesState = BatchItem[];

const initialState: BatchesState = [];

const batchesSlice = createSlice({
  name: Slices.BATCHES,
  initialState,
  reducers: {
    clearBatches: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBatches.pending, () => {
        return initialState;
      })
      .addCase(getBatches.fulfilled, (_, { payload }) => {
        return normalizeBatches(payload);
      })
      .addCase(getBatches.rejected, () => {
        return initialState;
      });
  },
});

export const { clearBatches } = batchesSlice.actions;

export default batchesSlice.reducer;
